/**
 * Logic phân quyền contact phía client.
 * Trích từ ChatPage/index.jsx (block filter trước khi render contactList).
 *
 * Mặc định backend đã applyPermissionFilters rồi — hàm này là defense-in-depth
 * để client tự bảo vệ khi merge multi-shop data ở client.
 */
export const isOwnerOrShopAdmin = (user, shop) => {
  if (!user || !shop) return false;
  if (user.role?.includes("admin")) return true;
  if (user._id === shop.staffId) return true;
  const shopRole = user.shopRoles?.find((sr) => sr.shopId === shop._id);
  if (shopRole?.role?.includes("admin")) return true;
  return false;
};

/**
 * Lọc contacts theo permission per-shop.
 * @param {Array} contacts - Array các contact (đã đính kèm shop_id)
 * @param {Object} user - Auth user (state.auth.user)
 * @param {Array} shops - state.shops.data (toàn bộ shops user có quyền xem)
 */
export const filterContactsByPermission = (contacts, user, shops = []) => {
  if (!Array.isArray(contacts) || contacts.length === 0) return [];
  if (!user) return [];
  const shopById = new Map(shops.map((s) => [s._id, s]));

  return contacts.filter((contact) => {
    const shop = shopById.get(contact.shopId);
    if (!shop) return false; // contact thuộc shop user không có quyền thấy

    // Bypass: global admin / shop owner / shop-level admin
    if (isOwnerOrShopAdmin(user, shop)) return true;

    const shopRole = user.shopRoles?.find((sr) => sr.shopId === shop._id);
    const permissions = shopRole?.permissions || [];
    const viewMoreStaffIds = shopRole?.viewMoreStaffIds || [];
    const staffIds = Array.isArray(contact.staffIds) ? contact.staffIds : [];

    // view_only_own_contact: chỉ thấy contact mình hoặc người trong viewMore
    if (permissions.includes("view_only_own_contact")) {
      const ownedByMe = staffIds.includes(user._id);
      const ownedByViewMore = staffIds.some((sid) =>
        viewMoreStaffIds.includes(sid),
      );
      const noOneManage = staffIds.length === 0;
      const allowed =
        ownedByMe ||
        ownedByViewMore ||
        (noOneManage && !permissions.includes("not_view_contact_no_one_manage"));
      if (!allowed) return false;
    } else if (permissions.includes("not_view_contact_no_one_manage")) {
      if (staffIds.length === 0) return false;
    }

    return true;
  });
};

/**
 * Lọc shops user được phép thấy (mặc định state.shops.data đã filter,
 * nhưng hàm này có sẵn nếu cần lọc thêm).
 */
export const getAccessibleShops = (user, shops = []) => {
  if (!user) return [];
  if (user.role?.includes("admin") || user.role?.includes("super_admin")) {
    return shops;
  }
  return shops.filter(
    (shop) =>
      shop.staffId === user._id ||
      user.shopRoles?.some((sr) => sr.shopId === shop._id),
  );
};
